const instructionsTempleates = {
    "kitchen": {
        "floor standing": [1,3,35,44,51,72,77,82],
        "frame & shutter":[3,13,35,44,72,82],
        "float": [2,35,44],
        "suspended":[12,35,44,50,72,82],
        "semi-modular": [3,13,35,44,72,82],
        "decko floor standing-without skirting": [69, 70],
        "decko floor standing-with skirting": [69, 70, 72, 77]
    },
    "d-kitchen": {
        "kitchen":[46,55],
        "d-floor standing": [28,55],
        "d-frame & shutter":[28,55],
        "d-Float": [28,55],
        "d-semi-modular": [28,55],
        "d-floor standing-with skirting": [28,55, 69, 70, 72, 77],
        "d-floor standing-without skirting": [28,55, 69, 70]
    },
    "doowup":{
        "other-doowup-modules":[47],
    },
    "wardrobe":{
        "floor-to-ceiling": [8,9,35,53,71],
        "hinged": [4,9,33,35,73,82],
        "slide and fold":[7,9,35,82],
        "sliding-inset":[6,9,35],
        "sliding-overlay": [5,9,39],
        "versa hinge wardrobe": [52,73],
        "decko inset": [63, 69],
        "decko hinged": [66, 69, 70],
        "decko floor to ceiling": [67],
        "versa floor-to-ceiling": [74],
        "flex composite floor-to-ceiling": [75],
        "o series hinged wardrobe": [79]
    },
    "d-wardrobe":{
        "d-floor to ceiling": [67],
        "d-hinged": [30,33, 66, 69, 70],
        // "d-slide & fold":[7,9],
        "d-sliding-inset":[63, 69],
        // "d-sliding-overlay": [5,9]
        "d-flex composite floor-to-ceiling": [75],
    },
    "storage":{
        "bar unit": [9,35,36,78, 81],
        "crockery unit": [21,35],
        "entertainment unit": [20,35,36,37],
        "foyer unit":[18,25,35],
        "pooja unit": [32,34,45],
        "study unit": [19,35,38],
        "study table": [19,35,38],
        "foyer unit with ventilation":[25,35],
        "floor standing vanity unit":[12,51],
        "suspended vanity unit":[12,50],
        "utility":{
            "floor standing": [10,35]
        },
        "room divider":[31, 76],
        "storio -m- series":[42,43],
        "decko crockery": [61, 69, 70],
        "decko foyer unit": [62, 69, 70],
        "decko puja unit ": [64, 69],
        "decko shelf": [65, 69],
        "decko beds": [69],
        "decko entertainment": [69, 70],
        "decko storio m series": [69],
        "decko study unit": [69, 70],
        "decko vanity": [68, 69],
    },
    "d-storage":{
        // "d-bar unit": [9,11],
        "d-crockery": [61, 69, 70],
        "d-entertainment": [29, 69, 70],
        "d-foyer unit":[62, 69, 70],
        "d-pooja unit": [64, 69],
        "d-study unit": [58, 69, 70],
        // "d-study table": [19],
        // "d-foyer unit with ventilation":[25],
        // "d-utility":{
        //     "d-floor standing": [10]
        // },
        // "d-vanity":{
        //     "d-suspended":[12],
        //     "d-floor standing":[12]
        // }
        "d-storio m series":[60, 69],
        "d-shelf": [65, 69],
        "d-vanity": [68, 69],
        "d-beds": [69]
    },
    "miscelleneous":{
        "wall mirror": [22],
        "bedside table": [9],
        "bookshelf": [9,11],
        "chest of drawer": [1, 8, 23,35,38],
        "window seating": [9],
        "room divider": [31],
        "wall panelling": [37],
        "partition system": [24,48],
        "hl-juniors":[40],
        "modular beds": [49, 59]
    },
    // "d-miscelleneous":{
    //     "d-wall mirror": [22],
    //     "d-bedside table": [9],
    //     "d-bookshelf": [9,11],
    //     "d-chest of drawer": [1, 8, 23],
    //     "d-window seating": [9],
    //     "d-room divider": [11],
    //     "d-wall panelling": [9],
    //     "d-partition system": [24]
    // },
    "hdsServices":{
        "countertop":[17],
        "painting":[15],
        "wallpaper":[16],
        "wallCladding": [80],
    },
    // "d-hdsServices":{
    //     "d-countertop":[17],
    //     "d-painting":[15],
    //     "d-wallpaper":[16],
    // },
    "loft":{
        "box loft":[26],
        "frame and shutter":[27,82],
        "o series frame and shutter": [79]
    },
    "loose-furniture":{
        "hl-junior":[40],
        "hl-beds":[41, 83, 84],
        "puja-unit":[56],
    },
    "d-loose-furniture":{
        "puja-unit":[57],
    }
    // "d-loft":{
    //     "d-box loft":[26],
    //     "d-frame and shutter":[27]
    // }

}

export default instructionsTempleates;
